import React from 'react';
import { TableHead, TableRow, TableCell, Checkbox } from '@mui/material';
import { HEADER_CELL_SX } from '../../constants/table';

// forwardRef เพราะต้นฉบับวัดความสูงจริงของ thead (theadRef.current.offsetHeight) ไปคำนวณ sticky top
// ของแถวหัวกลุ่มเลขบัญชีใน useStickyAccountGroups — ต้อง forward ref ทะลุไปที่ <TableHead> ตรงๆ
// ไม่งั้นวัดความสูงไม่ได้
const ExpenseTableHead = React.forwardRef(function ExpenseTableHead(
  { mode, allSelected, selectedCount, onToggleSelectAll },
  ref,
) {
  return (
    <TableHead ref={ref}>
      <TableRow>
        <TableCell align="center" padding="checkbox" sx={HEADER_CELL_SX}>
          <Checkbox
            size="small"
            checked={allSelected}
            indeterminate={!allSelected && selectedCount > 0}
            onChange={onToggleSelectAll}
            sx={{
              color: 'rgba(255,255,255,0.7)',
              '&.Mui-checked, &.MuiCheckbox-indeterminate': {
                color: '#fff',
              },
            }}
          />
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          ลำดับ
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          รหัสรายการเบิก
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          {mode.headStatus}
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          วันที่ (สร้าง / อนุมัติ / จ่ายเงิน)
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          งาน-รหัสงบ
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          ยอดเบิก
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          บัญชีผู้รับเงิน
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          รายละเอียด
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          อนุมัติ
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          {mode.headActor}
        </TableCell>
        <TableCell align="center" sx={HEADER_CELL_SX}>
          {mode.headNote}
        </TableCell>
      </TableRow>
    </TableHead>
  );
});

export default ExpenseTableHead;
